/**
 * Display labels for external credit import sources (CreditRecord.externalSource).
 * The API's import list carries displayName for *available* sources; this map covers
 * credits imported earlier from a source that may since have been switched off.
 */
const EXTERNAL_SOURCE_LABELS: Record<string, string> = {
  picpa: 'PICPA',
  cpax: 'CPAx',
};

export function externalSourceLabel(source: string): string {
  return EXTERNAL_SOURCE_LABELS[source.toLowerCase()] ?? source.toUpperCase();
}
